
import { User as SupabaseUser } from '@supabase/supabase-js';

export interface ExtendedUser extends SupabaseUser {
  name?: string;
  avatarUrl?: string;
  plan?: 'free' | 'pro' | 'team' | 'starter' | 'business';
  creditsUsed?: number;
  creditsLimit?: number;
  isAdmin?: boolean;
  businessName?: string;
  referralCode?: string;
  monthly_images_used?: number;
  monthly_scripts_used?: number;
  monthly_audio_minutes_used?: number;
  images_limit?: number;
  scripts_limit?: number;
  audio_minutes_limit?: number;
}

export interface UserProfile {
  id: string;
  user_id: string;
  full_name?: string;
  avatar_url?: string;
  plan?: 'free' | 'pro' | 'team' | 'starter' | 'business';
  credits_used?: number;
  credits_limit?: number;
  business_name?: string;
  referral_code?: string;
}

export const safeCastPlan = (plan: string | null | undefined): 'free' | 'pro' | 'team' | 'starter' | 'business' => {
  if (plan === 'business') return 'team';
  if (plan === 'starter') return 'pro';
  if (plan === 'pro' || plan === 'team') {
    return plan;
  }
  return 'free'; // default fallback
};
